import { render, staticRenderFns } from "./file-remark.vue?vue&type=template&id=866c03aa&"
import script from "./file-remark.vue?vue&type=script&lang=js&"
export * from "./file-remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports